import React from "react";
import "./TranslationTypes.css";
const TranslationTypes = () => {
  return (
    <div className="translationTypesContainer">
      <h2>
        Types of <span>Translation</span> Services We Offer
      </h2>
      <ul>
        <li>
          <h3>
            <span>1.</span> Business Translation :{" "}
          </h3>{" "}
          Conversion of commercial and administrative business documents for
          internal or external purposes.
        </li>
        <li>
          <h3>
            <span>2.</span> Technical Translation :{" "}
          </h3>{" "}
          Translation of technical content such as user manuals, patents, and
          technical brochures by experts well-versed in technical jargon.
        </li>
        <li>
          <h3>
            <span>3.</span> Legal Translation :{" "}
          </h3>{" "}
          Translation of legal documents, often requiring attestation and
          certified translators.
        </li>
        <li>
          <h3>
            <span>4.</span> Medical Translation :{" "}
          </h3>{" "}
          Conversion of medical documents, including research papers, patient
          information, and medical prescriptions.
        </li>
        <li>
          <h3>
            <span>5.</span> Financial Translation :{" "}
          </h3>{" "}
          Translation of financial documents such as balance sheets, financial
          reports, and bank statements.
        </li>
        <li>
          <h3>
            <span>6.</span> Literary Translation :{" "}
          </h3>{" "}
          Translation of literary works, including poems, novels, blogs, and
          other literary content.
        </li>
        <li>
          <h3>
            <span>7.</span> Academic Translation :{" "}
          </h3>{" "}
          Translation of academic texts, including credentials, textbooks, and
          pamphlets.
        </li>
        <li>
          <h3>
            <span>8.</span> Website Translation :{" "}
          </h3>
          Translation of web pages to reach target audiences and generate
          adequate traffic.
        </li>
        <li>
          <h3>
            <span>9.</span> Script Translation : 
          </h3>{" "}
          Translation of scripts for theatrical productions, films, short web
          videos, and other purposes
        </li>
      </ul>
    </div>
  );
};

export default TranslationTypes;
